function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { urlSearchParams } from "../constants";
import { CALL_API } from "../middleware/api";
export var GET_INVESTMENTITEMTYPES_REQUEST = "GET_INVESTMENTITEMTYPES_REQUEST";
export var GET_INVESTMENTITEMTYPES_SUCCESS = "GET_INVESTMENTITEMTYPES_SUCCESS";
export var GET_INVESTMENTITEMTYPES_FAILURE = "GET_INVESTMENTITEMTYPES_FAILURE";
export var RESET_GET_INVESTMENTITEMTYPES = "RESET_GET_INVESTMENTITEMTYPES";

// Fetches all investmentItemTypes from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchInvestmentItemTypes = function fetchInvestmentItemTypes() {
  return _defineProperty({}, CALL_API, {
    types: [GET_INVESTMENTITEMTYPES_REQUEST, GET_INVESTMENTITEMTYPES_SUCCESS, GET_INVESTMENTITEMTYPES_FAILURE],
    endpoint: "investmentItemTypes?sort=name,asc",
    init: {
      credentials: "same-origin"
    }
  });
};
export var GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_REQUEST = "GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_REQUEST";
export var GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_SUCCESS = "GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_SUCCESS";
export var GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_FAILURE = "GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_FAILURE";
export var RESET_GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN = "RESET_GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN";

// Fetches all investmentItemTypes from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchInvestmentItemTypesByInvestmentItemsMarketCountryIdIn = function fetchInvestmentItemTypesByInvestmentItemsMarketCountryIdIn(investmentItemsMarketCountryIds) {
  var queryString = urlSearchParams({
    sort: "createdAt,desc",
    investmentItemsMarketCountryIds: investmentItemsMarketCountryIds
  });
  return _defineProperty({
    investmentItemsMarketCountryIds: investmentItemsMarketCountryIds
  }, CALL_API, {
    types: [GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_REQUEST, GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_SUCCESS, GET_INVESTMENTITEMTYPESBYINVESMTENTITEMSMARKETCOUNTRYIDIN_FAILURE],
    endpoint: "investmentItemTypes/search/findByInvestmentItemsMarketCountryIdIn".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};